import { render, staticRenderFns } from "./SecondRound.vue?vue&type=template&id=9860626a&"
import script from "./SecondRound.vue?vue&type=script&lang=js&"
export * from "./SecondRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports